import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { DeleteTestDataResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

const deleteTestData = async (): Promise<DeleteTestDataResponseDto> => {
  const response = await apiFetch("api/admin/test-data", {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response));
  }

  return response.json();
};

export const useDeleteTestData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTestData,
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["reservation-requests"] }),
        queryClient.invalidateQueries({ queryKey: ["events"] }),
      ]),
  });
};
